module.exports = __webpack_public_path__ + "img/icon-apartment.fa8c919b.svg";